var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarSecondaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69824 11H9.69824V13H7.69824V11ZM7.69824 15H9.69824V17H7.69824V15ZM11.6982 11H13.6982V13H11.6982V11ZM11.6982 15H13.6982V17H11.6982V15ZM15.6982 11H17.6982V13H15.6982V11ZM15.6982 15H17.6982V17H15.6982V15Z",
    fill: "#0F0B55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69824 22H19.6982C20.8012 22 21.6982 21.103 21.6982 20V6C21.6982 4.897 20.8012 4 19.6982 4H17.6982V2H15.6982V4H9.69824V2H7.69824V4H5.69824C4.59524 4 3.69824 4.897 3.69824 6V20C3.69824 21.103 4.59524 22 5.69824 22ZM19.6982 8L19.6992 20H5.69824V8H19.6982Z",
    fill: "#0F0B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSecondaryIcon);
export default __webpack_public_path__ + "static/media/CalendarSecondaryIcon.890ffed8f121bd2ebbea76548dbc6676.svg";
export { ForwardRef as ReactComponent };